import Slides from "../section/home/Slides/Slides";
import Featurette from "../section/home/Featurette/Featurette";
import MainColumns from "../section/home/MainColumns/MainColumns";

const Home = () => {
  return (
    <>
    <Slides />
    <MainColumns />
    <Featurette />
    </>
  )
}

export default Home;